import Icon from 'components/icon/Icon';
import router from 'next/router';

import {
  CardStyled,
  DetailText,
  DetailTitle,
  Row,
} from './RemainingServicesBalance.styles';

export interface RemainingServicesProps {
  remainingServices?: number;
  balance?: number;
}

const findStatus = (remainingServicesnumber: number) => {
  let result;
  if (remainingServicesnumber >= 4) {
    result = 'green';
  } else if (remainingServicesnumber < 4 && remainingServicesnumber !== 0) {
    result = 'yellow';
  } else {
    result = 'orange';
  }
  return result;
};

const RemainingServicesBalance = ({
  remainingServices,
  balance,
}: RemainingServicesProps): JSX.Element => {
  return (
    <CardStyled
      statusColor={
        remainingServices !== undefined ? findStatus(remainingServices) : 'blue'
      }
      statusSize="medium"
      onClick={() => router.push('/transactions')}
    >
      <Row>
        <DetailTitle>
          <Icon type="gearWrench" size="lg" />
          {remainingServices !== undefined ? 'Services remaining:' : 'Balance:'}
        </DetailTitle>
        <DetailText>
          {remainingServices !== undefined
            ? remainingServices
            : `${balance || 0} USD`}
        </DetailText>
      </Row>
    </CardStyled>
  );
};

export default RemainingServicesBalance;
